import { render, staticRenderFns } from "./LayoutPanoramica.vue?vue&type=template&id=76b0082c&scoped=true&"
import script from "./LayoutPanoramica.vue?vue&type=script&lang=js&"
export * from "./LayoutPanoramica.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPanoramica.vue?vue&type=style&index=0&id=76b0082c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b0082c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b0082c')) {
      api.createRecord('76b0082c', component.options)
    } else {
      api.reload('76b0082c', component.options)
    }
    module.hot.accept("./LayoutPanoramica.vue?vue&type=template&id=76b0082c&scoped=true&", function () {
      api.rerender('76b0082c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/LayoutPanoramica.vue"
export default component.exports